const buildType = require("./models");
const { toDate } = require("../lib/misc");

const BankAccountBalance = buildType({
  initializer: (model, document) => {
    model.account = document?.account;
    model.balance = document?.balance;
    model.date = toDate(document?.date);
    model.isAutomatic = document?.isAutomatic;
  },
  code: "bankAccountBalances",
  singular: "Bank Account Balance",
  plural: "Bank Account Balances",
  save: async (balance, create, update, database) => {
    console.log("Preparing to save balance", balance);
    balance.balance = Number(balance.balance);
    balance.id = `${balance.account.id}-${balance.date.substring(0, 10)}`;
    console.log("Saving balance", balance);
    const account = await database.get("bankAccounts", balance.account.id);
    if (account.currentBalance == null || toDate(balance.date).getTime() >= toDate(account.currentBalance.date).getTime()) {
      account.currentBalance = { ...balance };
      await database.set("bankAccounts", account.id, account);
    }
    await database.setOrCreate("bankAccountBalances", balance.id, balance);
  },
});

BankAccountBalance.prototype.getStatusWarning = function () {
  if (!this.account) {
    return {
      severity: "critical",
      message: "missing account",
      code: "missing",
      field: "account",
    };
  }
  if (!this.date) {
    return {
      severity: "critical",
      message: "missing date",
      code: "missing",
      field: "date",
    };
  }
  if (!this.balance) {
    return {
      severity: "critical",
      message: "missing balance",
      code: "missing",
      field: "balance",
    };
  }
  return undefined;
};

module.exports = BankAccountBalance;
